<app-label-configuration
  [title]="'P00037.installation.consignemanuel' | translate"
  [titleListe]="'P00037.installation.consignemanuel' | translate"
  [description]="'P00037.installation.consignemanuel.description' | translate"
  [value]="actionStack!.getValue('elPConsigneManuel')"
  [liste]="P00037ConsigneManuel"
  [warningMode]="getProductDeviceTableFromPool()"
  (onPress)="
    this.actionStack!.editValue(
      P00039DataRxTxIndex.SALT_Parametrage1,
      'elPConsigneManuel',
      $event
    );
    this.actionStack!.commit()
  "
>
</app-label-configuration>

<app-information-title
  [title]="'P00037.installation.horloge' | translate"
  [information]="openEnSavoirPlus"
></app-information-title>

<app-two-choices-control
  [firstLabel]="
    'P00039.lighting.functionality.parameters.setting.title.clock.day'
      | translate
  "
  [firstValue]="0"
  [secondLabel]="
    'P00039.lighting.functionality.parameters.setting.title.clock.week'
      | translate
  "
  [secondValue]="1"
  [value]="actionStack!.getValue('elPTypeHorloge')"
  (onChange)="
    this.actionStack!.editValue(
      P00039DataRxTxIndex.SALT_Parametrage1,
      'elPTypeHorloge',
      $event
    );
    this.actionStack!.commit()
  "
>
</app-two-choices-control>

@if (this.actionStack!.getValue('elPTypeHorloge') === 0) {
  <app-larged-link
    [name]="
      'P0003600.installation.filtration.programmePPH.horlogePicotsJoursPPH.programmeTitre'
        | translate
    "
    (onPress)="goToFunctionParametersSettingsClockScreen()"
  >
  </app-larged-link>
} @else {
  <app-larged-link
    [name]="
      'P0003600.installation.filtration.programmePPH.horlogePicotsJoursPPH.programmeTitre'
        | translate
    "
    (onPress)="goToFunctionParametersSettingClockWeekScreen()"
  >
  </app-larged-link>
}

<app-label-description
  [description]="'P00037.installation.descriptionHorloge' | translate"
></app-label-description>

<app-label-configuration
  [title]="'P00037.installation.volet' | translate"
  [titleListe]="'P00037.installation.abaissement' | translate"
  [description]="
    'P00037.installation.abaissementProduction.description' | translate
  "
  [value]="actionStack!.getValue('elPTauxAbaissementVolet')"
  [liste]="P00037TauxAbaissement"
  (onPress)="
    this.actionStack!.editValue(
      P00039DataRxTxIndex.SALT_Parametrage1,
      'elPTauxAbaissementVolet',
      $event
    );
    this.actionStack!.commit()
  "
>
</app-label-configuration>

@if (hasProduitP00032()) {
  <app-label-configuration
    [title]="'P00037.installation.regulation' | translate"
    [titleListe]="'P00037.installation.regulation.value' | translate"
    [information]="P00037ESPInstallationClModal"
    [value]="actionStack!.getValue('elPConsigneRX')"
    [liste]="P00037ConsigneRegulationRxEnum"
    (onPress)="
      this.actionStack!.editValue(
        P00039DataRxTxIndex.SALT_Parametrage1,
        'elPConsigneRX',
        $event
      );
      this.actionStack!.commit()
    "
  >
  </app-label-configuration>

  <app-label-configuration
    [titleListe]="'P00037.installation.hysteresis.value' | translate"
    [value]="actionStack!.getValue('elPHysteresisRegulationRX')"
    [liste]="P00037HysteresisRegulationRx"
    (onPress)="
      this.actionStack!.editValue(
        P00039DataRxTxIndex.SALT_Parametrage1,
        'elPHysteresisRegulationRX',
        $event
      );
      this.actionStack!.commit()
    "
  >
  </app-label-configuration>

  <app-switch-configuration
    [nameCustom]="'P00037.installation.automaintien.value' | translate"
    [value]="
      actionStack!.getValue('elIActivationFonctionPrioriteAutoMaintien') !== 0
    "
    (onPress)="
      this.actionStack!.editValue(
        P00039DataRxTxIndex.SALT_Installation,
        'elIActivationFonctionPrioriteAutoMaintien',
        $event ? 1 : 0
      );
      this.actionStack!.commit()
    "
  >
  </app-switch-configuration>

  <app-label-description
    [description]="'P00037.installation.regulation.description' | translate"
  ></app-label-description>
}

<app-switch-configuration
  [title]="'P00037.reglage.hivernage' | translate"
  [nameCustom]="'P00037.reglage.activationfct' | translate"
  [value]="actionStack!.getValue('elPActivationHivernage') !== 0"
  [information]="EnSavoirPlusPage"
  (onPress)="
    this.actionStack!.editValue(
      P00039DataRxTxIndex.SALT_Parametrage1,
      'elPActivationHivernage',
      $event ? 1 : 0
    );
    this.actionStack!.commit()
  "
>
</app-switch-configuration>

@if (actionStack!.getValue('elPActivationHivernage') === 1) {
  <app-label-configuration
    [titleListe]="'P00037.reglage.seuilTemp' | translate"
    [value]="actionStack!.getValue('elPTemperatureHivernage')"
    [liste]="P00037TemperatureHivernage()"
    (onPress)="
      this.actionStack!.editValue(
        P00039DataRxTxIndex.SALT_Parametrage1,
        'elPTemperatureHivernage',
        $event
      );
      this.actionStack!.commit()
    "
  >
  </app-label-configuration>
}

<app-label-description
  [description]="'P00037.reglage.hivernage.description' | translate"
></app-label-description>

<app-switch-configuration
  [title]="'P00037.installation.comportement' | translate"
  [nameCustom]="'P00037.installation.comportement.value' | translate"
  [description]="'P00037.installation.comportement.description' | translate"
  [value]="
    actionStack!.getValue('elIActivationFonctionPrioriteElectrolyse') !== 0
  "
  (onPress)="
    this.actionStack!.editValue(
      P00039DataRxTxIndex.SALT_Installation,
      'elIActivationFonctionPrioriteElectrolyse',
      $event ? 1 : 0
    );
    this.actionStack!.commit()
  "
>
</app-switch-configuration>

<app-switch-configuration
  [title]="'P00037.installation.comportementBoost' | translate"
  [nameCustom]="'P00037.installation.comportementBoost.value' | translate"
  [description]="
    'P00037.installation.comportementBoost.description' | translate
  "
  [value]="actionStack!.getValue('elIActivationFonctionPrioriteBoost') !== 0"
  [warningMode]="getLabelConfigurationWarningModeFromACU(this.getPool(), 9)!"
  (onPress)="
    this.actionStack!.editValue(
      P00039DataRxTxIndex.SALT_Installation,
      'elIActivationFonctionPrioriteBoost',
      $event ? 1 : 0
    );
    this.actionStack!.commit()
  "
>
</app-switch-configuration>
